import React from 'react';
import IconInitialCall from '../icons/IconInitialCall';
import IconOverviewAndApply from '../icons/IconOverviewAndApply';
import IconDueDiligence from '../icons/IconDueDiligence';
import IconSiteVisit from '../icons/IconSiteVisit';
import IconReviewSign from '../icons/IconReviewSign';
import IcontreningAndLounch from '../icons/IcontreningAndLounch';

const RoadToSuccess = ({toSection,section}) => {
  // Custom SVG icons for each step

  const MessageIcon = ({ color = "#002147" }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 12H30C31.1046 12 32 12.8954 32 14V26C32 27.1046 31.1046 28 30 28H10C8.89543 28 8 27.1046 8 26V14C8 12.8954 8.89543 12 10 12Z" stroke={color} strokeWidth="2"/>
      <path d="M32 14L20 21L8 14" stroke={color} strokeWidth="2"/>
    </svg>
  );
  
  const OverviewIcon = ({ color = "#002147" }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="24" height="24" rx="2" stroke={color} strokeWidth="2"/>
      <path d="M14 16H26" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M14 20H26" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M14 24H20" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  
  const FinancialsIcon = ({ color = "#002147" }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="12" stroke={color} strokeWidth="2"/>
      <path d="M16 20H24" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M20 16L20 24" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  
  const DiscoveryIcon = ({ color = "#002147" }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="10" stroke={color} strokeWidth="2"/>
      <path d="M32 32L25 25" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M15 18H21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M18 15V21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  
  const SignIcon = ({ color = "#002147" }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 20L17 25L28 14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="8" y="8" width="24" height="24" rx="2" stroke={color} strokeWidth="2"/>
    </svg>
  );
  
  const LaunchIcon = ({ color = "#002147" }) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 8L24 16H16L20 8Z" stroke={color} strokeWidth="2"/>
      <path d="M12 32H28" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M20 16V32" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M12 24L28 24" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
  
  const steps = [
    {
      title: "Initial Call",
      description: "Fill out the form below to let us know you're interested in learning more. A Tinker Labs franchising expert will follow up with you.",
      Icon: <IconInitialCall />,
      color: "#183867", // Pink
      bgColor: "#fff"
    },
    {
      title: "Franchise Overview",
      description: "Our franchise coaches will guide you step by step and give you all the information about our business model and systems.",
      Icon: <IconOverviewAndApply />,
      color: "#183867", // Blue
      bgColor: "#fff"
    },
    {
      title: "Due Diligence",
      description: "From there, we'll begin our due diligence process, where we will mutually determine if we are a good financial and cultural fit for one another.",
      Icon: <IconDueDiligence />,
      color: "#183867", // Orange
      bgColor: "#fff"
    },
    {
      title: "Site Visit",
      description: "You'll be invited to a Discovery Day at one of our locations, where you can meet our franchise management team and ask more questions.",
      Icon: <IconSiteVisit />,
      color: "#183867", // Green
      bgColor: "#fff"
    },
    {
      title: "Review and Sign",
      description: "This step includes an offer for you to become a franchise partner, with time to revise and sign the agreements.",
      Icon: <IconReviewSign />,
      color: "#183867", // Light Blue
      bgColor: "#fff"
    },
    {
      title: "Training & Launch!",
      description: "Once you are ready to move forward, we can start going over your pre-opening procedures and prepare your business and teacher training!",
      Icon: <IcontreningAndLounch />,
      color: "#183867", // Dark Blue
      bgColor: "#fff"
    }
  ];

  return (
    <div style={{marginTop: '-40px'}} id={section} className="relative">
      {/* Top wave */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#fff"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div className="bg-[#002147] relative py-20">
        <div className="container mx-auto px-4 py-10">
          <h2 className="font-['Grandstander'] text-4xl font-extrabold text-center text-white mb-4">
            Path to Ownership
          </h2>
          <h3 className="font-['Lexend'] text-xl text-center text-white mb-16">
            If you're interested here are the steps to becoming an owner
          </h3>

          <div className="relative mx-auto">
  
            {/* Steps */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {steps.map((step, index) => (
                <div 
                  key={index} 
                  className="relative p-6 rounded-xl transition-all duration-300 hover:transform hover:scale-105"
                  style={{ backgroundColor: step.bgColor }}
                >
                  {/* Step Number */}
                  <div className="absolute font-['Lexend'] -top-4 -left-4 w-12 h-12 rounded-full  flex items-center justify-center text-white font-bold"
                    style={{ backgroundColor: '#183867' ,fontSize:'25px',border:'2px solid white'}}>
                    {index + 1}
                  </div>

                  <div className="flex items-center mb-4">
                  <div 
                className="w-16 h-16 rounded-full mb-4 flex items-center justify-center"
                 
              >
                      {step.Icon}
                    </div>
                    
                    <h3 className="font-['Grandstander'] ml-10 font-bold text-[#183867] text-xl">
                      {step.title}
                    </h3>
                  </div>

                  <p className="font-['Lexend'] text-[#183867]">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <path 
            fill="#fff"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default RoadToSuccess;